<template>
  <div class="fileinput text-center">
    <div class="border">
      <img :src="image" alt="preview" 
      class="image" width="100%" height="100%"/>
    </div>
    <div>
      <span class="btn btn-primary btn-simple btn-file">
        <span class="fileinput-new">{{
          fileExists ? changeText : selectText
        }}</span>
        <input type="hidden" value="" name="" />
        <input
          accept="image/*"
          @change="handlePreview"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
        />
      </span>
      <v-btn color="red" v-if="fileExists" @click="removeFile" round type="">
        <i class="fas fa-times"></i> {{ removeText }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'image-upload',
  props: {
    src: {
      type: String,
      default: '',
      description: 'Initial image to display'
    },
    selectText: {
      type: String,
      default: 'Select image'
    },
    changeText: {
      type: String,
      default: 'Change'
    },
    removeText: {
      type: String,
      default: 'Remove'
    }
  },
  data() {
    let imgPlaceholder = 'img/image_placeholder.jpg';
    return {
      placeholder: imgPlaceholder,
      imagePreview: null
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    image() {
      return this.imagePreview || this.src || this.placeholder;
    }
  },
  methods: {
    handlePreview(event) {
      let file = event.target.files[0];
      if (!file.name.match(/.(jpg|jpeg|png)$/i)){
        alert('Invalid image! Here only allow jpg and png image.');
      }else{
        this.imagePreview = URL.createObjectURL(file);
        this.$emit('change', file);
      }
    },
    removeFile() {
      this.imagePreview = null;
      this.$emit('change', null);
    }
  }
};
</script>
<style>
.border{
  border: 1.5px solid;
  padding:5px;
}
</style>
